import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProfileComponent } from './profile.component';
import { BasicInfoComponent } from './basic-info/basic-info.component';
import { TaxInfoComponent } from './tax-info/tax-info.component';
import { TaxInfoW9Component } from './tax-info-w9/tax-info-w9.component';
import { TranslateModule } from '@ngx-translate/core';
const routes: Routes = [
  { path: '', component: ProfileComponent, children: [
    { path: '', component: BasicInfoComponent  },
    { path: 'tax-infot4', component: TaxInfoComponent  },
    { path: 'tax-infow9', component: TaxInfoW9Component  },
  ]},
];

@NgModule({
  imports: [RouterModule.forChild(routes) ,TranslateModule],
  exports: [RouterModule]
})
export class ProfileRoutingModule { }
